module.exports = __webpack_public_path__ + "img/card-ccv.bcca5ab7.png";